<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form v-model="valid" lazy-validation @submit.prevent="submit" ref="form">
      <v-card-text class="pb-0">
        <v-row>
          <v-col v-if="isEdit" cols="3">
            <CameraCapturaFoto />
          </v-col>
          <v-col :cols="isEdit ? 9 : 12">
            <v-subheader class="font-weight-bold pt-5 pb-2">Tipo de Pessoa</v-subheader>
            <v-container fluid>
              <v-divider class="pb-0" />
              <v-radio-group v-model="formData.tipo" row>
                <v-radio label="Física" value="F"></v-radio>
                <v-radio label="Jurídica" value="J"></v-radio>
              </v-radio-group>
            </v-container>
            <v-subheader v-if="formData.tipo" class="font-weight-bold pt-3 pb-2">
              Documentos Pessoais
            </v-subheader>
            <v-container fluid v-if="formData.tipo">
              <v-divider class="pb-4" />
              <v-row>
                <v-col class="py-0" cols="4">
                  <v-text-field
                    :counter="18"
                    :error-messages="errors.cpf_cnpj"
                    :rules="rules.cpf_cnpj"
                    class="pa-0"
                    dense
                    label="CPF/CNPJ *"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    outlined
                    v-model="formData.cpf_cnpj"
                    @blur="checkDocumento"
                  >
                  </v-text-field>
                </v-col>

                <v-col class="py-0" cols="4" v-if="formData.tipo === 'F'">
                  <v-text-field
                    :counter="20"
                    :error-messages="errors.rg"
                    :rules="rules.rg"
                    class="pa-0"
                    dense
                    label="RG"
                    outlined
                    v-model="formData.rg"
                  >
                  </v-text-field>
                </v-col>

                <v-col class="py-0" cols="4" v-if="formData.tipo === 'F'">
                  <v-text-field
                    :counter="120"
                    :error-messages="errors.rg_orgao_expedidor"
                    :rules="rules.rg_orgao_expedidor"
                    class="pa-0"
                    dense
                    label="Orgão Expedidor"
                    outlined
                    v-model="formData.rg_orgao_expedidor"
                  >
                  </v-text-field>
                </v-col>

                <v-col class="py-0" cols="4" v-if="formData.tipo === 'J'">
                  <v-text-field
                    :counter="14"
                    :error-messages="errors.inscricao_municipal"
                    :rules="rules.inscricao_municipal"
                    class="pa-0"
                    dense
                    label="Inscrição Municipal"
                    outlined
                    v-model="formData.inscricao_municipal"
                  >
                  </v-text-field>
                </v-col>

                <v-col class="py-0" cols="4" v-if="formData.tipo === 'J'">
                  <v-text-field
                    :counter="14"
                    :error-messages="errors.inscricao_estadual"
                    :rules="rules.inscricao_estadual"
                    class="pa-0"
                    dense
                    label="Inscrição Estadual"
                    outlined
                    v-model="formData.inscricao_estadual"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <v-subheader v-if="formData.tipo" class="font-weight-bold pt-2 pb-2">
              Dados Pessoais
            </v-subheader>
            <v-container fluid v-if="formData.tipo">
              <v-divider class="pb-4" />
              <v-row>
                <v-col class="py-0" cols="12" v-if="formData.tipo === 'F'">
                  <v-text-field
                    :counter="200"
                    :error-messages="errors.nome"
                    :rules="rules.nome"
                    class="pa-0"
                    dense
                    label="Nome *"
                    outlined
                    v-model="formData.nome"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="formData.tipo === 'J'">
                  <v-text-field
                    :counter="200"
                    :error-messages="errors.razao_social"
                    :rules="rules.razao_social"
                    class="pa-0"
                    dense
                    label="Razão Social *"
                    outlined
                    v-model="formData.razao_social"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="py-0" cols="6" v-if="formData.tipo === 'J'">
                  <v-text-field
                    :counter="200"
                    :error-messages="errors.nome_fantasia"
                    :rules="rules.nome_fantasia"
                    class="pa-0"
                    dense
                    label="Nome Fantasia *"
                    outlined
                    v-model="formData.nome_fantasia"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-0" cols="3">
            <v-text-field
              :counter="15"
              :error-messages="errors.telefone_residencial"
              :rules="rules.telefone_residencial"
              class="pa-0"
              dense
              label="Telefone Residencial"
              v-mask="['(##) ####-####']"
              outlined
              v-model="formData.telefone_residencial"
            >
            </v-text-field>
          </v-col>
          <v-col class="py-0" cols="3">
            <v-text-field
              :counter="15"
              :error-messages="errors.telefone_comercial"
              :rules="rules.telefone_comercial"
              class="pa-0"
              dense
              label="Telefone Comercial"
              v-mask="['(##) ####-####', '(##) #####-####']"
              outlined
              v-model="formData.telefone_comercial"
            >
            </v-text-field>
          </v-col>
          <v-col class="py-0" cols="3">
            <v-text-field
              :counter="15"
              :error-messages="errors.telefone_celular"
              :rules="rules.telefone_celular"
              class="pa-0"
              dense
              label="Telefone Celular"
              v-mask="['(##) ####-####', '(##) #####-####']"
              outlined
              v-model="formData.telefone_celular"
            >
            </v-text-field>
          </v-col>

          <v-col class="py-0" cols="3">
            <v-text-field
              :counter="250"
              :error-messages="errors.email"
              :rules="rules.email"
              class="pa-0"
              dense
              label="E-mail"
              outlined
              v-model="formData.email"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-divider class="mt-4 mb-6"></v-divider>
        <table-enderecos />
      </v-card-text>
      <v-card-actions class="py-2 px-4">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid"
          :loading="isloadingSubmit"
          color="green"
          dark
          depressed
          type="submit"
        >
          <v-icon left small>mdi-send</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-form>
    <ModalUploadFotoForm />
    <ModalCapturaFotoForm />
    <modal-endereco-form />
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { max, min, required } from '@/services/util/validate';
import { mapActions, mapState } from 'vuex';
import pessoaHttp from '@/services/http/resources/configuracao/pessoaHttp';
import toastMessage from '@/services/util/alertService';
import TableEnderecos from './TableEnderecos.vue';
import ModalEnderecoForm from './ModalEnderecoForm.vue';
import CameraCapturaFoto from './CameraCapturaFoto.vue';
import ModalUploadFotoForm from './ModalUploadFoto.vue';
import ModalCapturaFotoForm from './ModalCapturaFoto.vue';

export default {
  name: 'PessoaForm',
  directives: {
    mask,
  },
  components: {
    ModalCapturaFotoForm,
    ModalUploadFotoForm,
    CameraCapturaFoto,
    TableEnderecos,
    ModalEnderecoForm,
  },
  data: () => ({
    title: 'Adicionar Pessoa',
    valid: true,
    formData: {
      id: '',
      nome: '',
      razao_social: '',
      nome_fantasia: '',
      tipo: 'F',
      cpf_cnpj: '',
      inscricao_municipal: '',
      inscricao_estadual: '',
      telefone_residencial: '',
      telefone_comercial: '',
      telefone_celular: '',
      rg: '',
      rg_orgao_expedidor: '',
      rg_data_emissao: '',
      url: null,
    },
    formDataDefault: {
      id: '',
      nome: '',
      razao_social: '',
      nome_fantasia: '',
      tipo: 'F',
      cpf_cnpj: '',
      inscricao_municipal: '',
      inscricao_estadual: '',
      telefone_residencial: '',
      telefone_comercial: '',
      telefone_celular: '',
      rg: '',
      rg_orgao_expedidor: '',
      rg_data_emissao: '',
      url: null,
    },
    rules: {
      nome: [(value) => max(value, 200)],
      tipo: [required],
      cpf_cnpj: [required, (value) => min(value, 14), (value) => max(value, 18)],
      rg: [(value) => max(value, 20)],
      rg_orgao_expedidor: [(value) => max(value, 120)],
      nascimento: [(value) => max(value, 10)],
      inscricao_municipal: [(value) => max(value, 14)],
      inscricao_estadual: [(value) => max(value, 14)],
      telefone: [(value) => max(value, 15)],
      email: [(value) => max(value, 250)],
    },
    errors: {
      nome: [],
      tipo: [],
      cpf_cnpj: [],
      rg: [],
      rg_orgao_expedidor: [],
      nascimento: [],
      inscricao_municipal: [],
      inscricao_estadual: [],
      telefone: [],
      email: [],
      complemento: [],
      bairro: [],
      cep: [],
      url: [],
    },
    loading: false,
    isloadingSubmit: false,
    isEdit: false,
  }),
  computed: {
    ...mapState('cgmEndereco', { enderecos: 'list' }),
    ...mapState('pessoa', ['dataIndex', 'data', 'dialogForm']),
    formTitle() {
      return this.dataIndex === -1 ? 'Nova Pessoa' : 'Editar Pessoa';
    },
  },
  created() {
    this.checkEdit();
  },
  methods: {
    ...mapActions('cgmEndereco', ['storeEnderecoAll']),
    ...mapActions('pessoa', ['find', 'updateFile', 'clearData', 'store', 'reset']),
    checkDocumento() {
      if (this.formData.cpf_cnpj || this.formData.id) {
        pessoaHttp
          .checkDocumento({ documento: this.formData.cpf_cnpj, id: this.formData.id })
          .then(({ data }) => {
            if (data.exist) {
              this.errors.cpf_cnpj.push('Documento em uso.');
            } else {
              this.errors.cpf_cnpj = [];
            }
          });
      }
    },
    checkEdit() {
      if (this.$route.params.id) {
        this.loading = true;
        this.find({ id: this.$route.params.id })
          .then(() => {
            this.openDialogForm();
            this.isEdit = true;
          })
          .catch(() => this.$router.back())
          .finally(() => {
            this.loading = false;
          });
      }
    },
    resetValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    openDialogForm() {
      Object.entries(this.formDataDefault).forEach(([key]) => {
        this.formData[key] = this.data[key];
      });
    },
    closeDialog() {
      setTimeout(() => {
        Object.entries(this.formDataDefault).forEach(([key]) => {
          this.formData[key] = this.formDataDefault[key];
        });
        this.resetValidation();
        this.clearData();
      }, 300);
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.isloadingSubmit = true;
        const isOpenModal = this.dialogForm;
        const actionHttp = !this.$route.params.id
          ? this.store(this.getFormData())
          : this.updateFile(this.getFormData());
        actionHttp
          .then(({ data: { data } }) => {
            this.$bus.$emit('checkPessoa', data);
            toastMessage.successSave('Pessoa salva com sucesso');
            this.resetValidation();
            if (!isOpenModal) {
              this.$router.push({ name: 'configuracao.pessoa.editar', params: { id: data.id } });
            }
          })
          .catch(({ response }) => {
            if (response.status === 422) {
              const { errors } = response.data;
              Object.entries(errors).forEach(([index, value]) => {
                this.errors[index].push(value.toString());
                toastMessage.errorValidation();
              });
            } else {
              toastMessage.errorSave('Erro ao salvar pessoa');
            }
          })
          .finally(() => {
            this.isloadingSubmit = false;
          });
      }
    },
    getFormData() {
      const formData = new FormData();
      const dataForm = this.formData;
      Object.entries(this.formDataDefault).forEach(([key]) => {
        if (dataForm[key] === null || dataForm[key] === undefined) {
          formData.append(key, '');
        } else {
          formData.append(key, dataForm[key]);
        }
      });
      return formData;
    },
  },
  watch: {
    'formData.nome': function () {
      this.errors.nome = [];
    },
    'formData.tipo': function () {
      this.errors.tipo = [];
    },
    'formData.cpf_cnpj': function () {
      this.errors.cpf_cnpj = [];
    },
    'formData.rg': function () {
      this.errors.rg = [];
    },
    'formData.rg_orgao_expedidor': function () {
      this.errors.rg_orgao_expedidor = [];
    },
    'formData.nascimento': function () {
      this.errors.nascimento = [];
    },
    'formData.inscricao_municipal': function () {
      this.errors.inscricao_municipal = [];
    },
    'formData.inscricao_estadual': function () {
      this.errors.inscricao_estadual = [];
    },
    'formData.telefone': function () {
      this.errors.telefone = [];
    },
    'formData.email': function () {
      this.errors.email = [];
    },
  },
  destroyed() {
    this.closeDialog();
    this.reset();
  },
};
</script>

<style scoped></style>
